
  import ScreenSize from '@/mixins/ScreenSize';
  import OrganizationSocialIcons from '@/components/OrganizationSocialIcons';
  import StarRatingActionButtonV2 from '@/components/StarRatingActionButtonV2';

  export default {
    components: {
      OrganizationSocialIcons,
      StarRatingActionButtonV2,
      OrganizationQuestionDialog: () =>
        import('@/components/OrganizationQuestionDialog'),
    },
    filters: {
      empty_default: function (value) {
        if (!value || value === '') {
          return 'k.A.';
        } else {
          return value;
        }
      },
      truncate(string, value) {
        return string.length > value
          ? string.substring(0, value) + '…'
          : string;
      },
    },
    mixins: [ScreenSize],
    props: {
      organization: {
        type: Object,
        require: true,
        default: () => {},
      },
    },
    data() {
      return {
        iconColor: 'primaryYellow--text',
        showMoreText: false,
        organizationSocialIcons: [
          {
            href: '',
            icon: 'fab fa-facebook-f',
            name: 'Facebook',
            route: null,
            target: '_blank',
            color: 'primaryYellow',
          },
          {
            href: '',
            icon: 'fab fa-instagram',
            name: 'Instagram',
            route: null,
            target: '_blank',
            color: 'primaryYellow',
          },
          {
            href: '',
            icon: 'fab fa-twitter',
            name: 'Twitter',
            route: null,
            target: '_blank',
            color: 'primaryYellow',
          },
          {
            href: '',
            icon: 'fab fa-linkedin-in',
            name: 'LinkedIn',
            route: null,
            target: '_blank',
            color: 'primaryYellow',
          },
          {
            href: '',
            icon: 'fab fa-xing',
            name: 'Xing',
            route: null,
            target: '_blank',
            color: 'primaryYellow',
          },
        ],
      };
    },
    created() {
      this.organizationSocialIcons[0].href = this.organization.facebookProfile;
      this.organizationSocialIcons[1].href = this.organization.instagramProfile;
      this.organizationSocialIcons[2].href = this.organization.twitterProfile;
      this.organizationSocialIcons[3].href = this.organization.linkedInProfile;
      this.organizationSocialIcons[4].href = this.organization.xingProfile;
    },
  };
